import type { EcsConfigIdTelemetry } from "owa-analytics-types";

export function partitionEcsConfigIds(configIds: string): EcsConfigIdTelemetry {
    const otherIds: string[] = [];
    const defaultIds: string[] = [];
    for (const entry of configIds.split(",")) {
        // Trim only for classification; preserve the original token and allocation fragment.
        const target = /^[pP]-[dD]-/.test(entry.trim()) ? defaultIds : otherIds;
        target.push(entry);
    }
    return {
        EcsConfigIds: otherIds.join(","),
        ...(defaultIds.length > 0 && { EcsDefaultConfigIds: defaultIds.join(",") }),
    };
}
